import { EuiBadge, EuiFlexGroup, EuiFlexItem } from "@elastic/eui";
import React from "react";

function TripTags({ tags, onRemove }) {
    return (
        <EuiFlexGroup
            gutterSize="s"
            responsive={false}
            wrap
        >
            <EuiFlexItem
                style={{ color: "#fff" }}
                grow={false}
            >
                <b>Tags:</b>
            </EuiFlexItem>
            {tags.map((tag) => (
                <EuiFlexItem
                    key={tag}
                    grow={false}
                >
                    <EuiBadge
                        color="hollow"
                        iconType="cross"
                        iconSide="right"
                        iconOnClick={() => onRemove(tag)}
                        iconOnClickAriaLabel="Remove trip tag"
                        data-test-sub="trip-tag"
                    >
                        {tag}
                    </EuiBadge>
                </EuiFlexItem>
            ))}
        </EuiFlexGroup>
    );
}

export default TripTags;
